module.exports = __webpack_public_path__ + "img/trash-2.d995781c.svg";